export default __webpack_public_path__ + "static/media/la_capelle5.fea0371c.jpg";